<div mat-dialog-content>
    <p>Tenga en cuenta que el enlace de invitación a la capacitación será enviado al correo electrónico <strong><span style="font-size: 18px">{{data.email}}</span></strong> , y será este mismo con el que tendrá acceso a la sesión de capacitación.</p>
</div>
<div mat-dialog-actions align="center">
    <button mat-raised-button  type="button" color="primary" [mat-dialog-close]="true">
        <mat-icon aria-hidden="false" aria-label="Confirmar">done</mat-icon>
        Es Correcto
    </button>
    <button mat-raised-button type="button" (click)="onNoClick()">Corregir Información</button>
</div>
